export default (() => null);
//# sourceMappingURL=BottomSheetRefreshControl.js.map